import { render, staticRenderFns } from "./cookiePop.vue?vue&type=template&id=5aca2a90&scoped=true&"
import script from "./cookiePop.vue?vue&type=script&lang=js&"
export * from "./cookiePop.vue?vue&type=script&lang=js&"
import style0 from "./cookiePop.vue?vue&type=style&index=0&id=5aca2a90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aca2a90",
  null
  
)

export default component.exports